'use strict'

/**
 * Vue Inscription
 */

import master from 'Modules/master'
import password from 'Modules/password'

password.setEventMotDePasseOublie()

master.process()
